import { useEffect, useRef } from 'react'

import logoImg from '../assets/img/logo.png'
import logoWhite from '../assets/img/logo-white.png'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const NavigationBar = () => {

  const sidemenuToggleRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const initializeNavigation = () => {
      if (typeof window !== 'undefined' && typeof window.$ === 'function') {
        window.$('.side-menu').removeClass('hidden')
        
        if (sidemenuToggleRef.current) {
          window.$("#sidemenu_toggle").on("click", function () {
            window.$(".side-menu").removeClass("side-menu-opacity")
            window.$(".pushwrap").toggleClass("active")
            window.$(".side-menu").addClass("side-menu-active")
            window.$("#close_side_menu").fadeIn(700)
          })
          
          window.$("#close_side_menu").on("click", function () {
            window.$(".side-menu").removeClass("side-menu-active")
            window.$(this).fadeOut(200)
            window.$(".pushwrap").removeClass("active")
            setTimeout(function () {
              window.$(".side-menu").addClass("side-menu-opacity")
            }, 500)
          })
          
          window.$(".side-nav .navbar-nav .nav-link").on("click", function () {
            window.$(".side-menu").removeClass("side-menu-active")
            window.$("#close_side_menu").fadeOut(200)
            window.$(".pushwrap").removeClass("active")
            setTimeout(function () {
              window.$(".side-menu").addClass("side-menu-opacity")
            }, 500)
          })
          
          window.$("#btn_sideNavClose").on("click", function () {
            window.$(".side-menu").removeClass("side-menu-active")
            window.$("#close_side_menu").fadeOut(200)
            window.$(".pushwrap").removeClass("active")
            setTimeout(function () {
              window.$(".side-menu").addClass("side-menu-opacity")
            }, 500)
          })
        }

        window.$(function () {
          window.$(document).scroll(function () {
            const $nav = window.$(".navbar-fixed-top")
            const scrollTop = window.$(this).scrollTop()
            const height = $nav.height()
            if (scrollTop && height) $nav.toggleClass('scrolled', scrollTop > height)
          })
        })
      }
    }

    // Initialize immediately if jQuery is available, otherwise wait for the event
    if (typeof window !== 'undefined' && typeof window.$ === 'function') {
      initializeNavigation()
    } else {
      // Listen for jQuery ready event
      const handleJQueryReady = () => {
        initializeNavigation()
      }
      
      window.addEventListener('jqueryReady', handleJQueryReady)
      
      // Fallback timeout
      const timer = setTimeout(() => {
        if (typeof window.$ === 'function') {
          initializeNavigation()
        }
      }, 500)
      
      return () => {
        window.removeEventListener('jqueryReady', handleJQueryReady)
        clearTimeout(timer)
      }
    }
  }, [])

  return (
    <header className="navigation-bar">
      <nav className="navbar navbar-expand-lg fixed-top navbar-fixed-top">
        <Container>
          <Link className="navbar-brand" to="/">
            <img src={logoImg} alt="Pandit Ji Services" />
          </Link>
          
          {/* Desktop Navigation - Hidden on mobile */}
              <div className="desktop-nav d-none d-lg-flex align-items-center">
                <ul className="navbar-nav mx-auto">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">HOME</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/services">SERVICES</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/about">ABOUT</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/gallery">GALLERY</Link>
                  </li>
                </ul>
            <div className="navbar-cta">
              <Link className="btn button btn-rounded pink-btn btn-hvr-black" to="/contact">GET IN TOUCH</Link>
            </div>
          </div>

          {/* Mobile Menu Toggle - Only visible on mobile */}
          <button 
            ref={sidemenuToggleRef} 
            type="button"
            className="sidemenu_btn link d-lg-none" 
            id="sidemenu_toggle"
          >
            <span />
            <span />
            <span />
          </button>
        </Container>
      </nav>
      <div className="side-menu hidden side-menu-opacity">
        <div className="inner-wrapper">
          <span className="btn-close" id="btn_sideNavClose"><i /><i /></span>
          <Container>
            <Row className="side-menu-inner-content">
              <Col xs={12} className="d-flex justify-content-center align-items-center text-center">
                <Link className="logo-image" to="/">
                  <img src={logoWhite} alt="logo" /></Link>
              </Col>
              <Col xs={12} lg={8} className="text-center text-lg-left">
                    <nav className="side-nav w-100">
                      <ul className="navbar-nav">
                        <li className="nav-item">
                          <Link className="nav-link" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/services">Services</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/about">About</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/gallery">Gallery</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/contact">Get in Touch</Link>
                        </li>
                      </ul>
                    </nav>
              </Col>
              <Col xs={12} lg={4} className="d-flex align-items-center text-center text-lg-left">
                <div className="side-footer text-white w-100">
                  <div className="menu-company-details">
                    <span>+91 7461809418</span>
                  </div>
                  <ul className="social-icons-simple">
                    <li><a className="icon-hovr" href="#" onClick={(e) => e.preventDefault()}><i className="fab fa-facebook-f" /> </a> </li>
                    <li><a className="icon-hovr" href="#" onClick={(e) => e.preventDefault()}><i className="fab fa-twitter" /> </a> </li>
                    <li><a className="icon-hovr" href="#" onClick={(e) => e.preventDefault()}><i className="fab fa-youtube" /> </a> </li>
                    <li><a className="icon-hovr" href="#" onClick={(e) => e.preventDefault()}><i className="fab fa-instagram" /> </a> </li>
                  </ul>
                  <p className="text-white">© {(new Date).getFullYear()} Pandit Nilesh Pandey. All rights reserved.<br />Developed by <a href="https://imedhya.com" target="_blank" rel="noopener noreferrer" style={{color: '#FFD700', textDecoration: 'none'}}>Medhya Digital</a></p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <a id="close_side_menu" href="#" onClick={(e) => e.preventDefault()} />
    </header>
  )
}

export default NavigationBar